var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { ContextMenuAFY, icons, sizesIcon, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import newExcel from "../../../../../assets/images/newExcel.svg";
import { hasAuditRole, hasPermission, } from "../../../../../services/getNavigationPages";
import { getDefaultCheckedStatusItems, hasProductPermissionRestriction, } from "../../../hook/insurancePoliciesSummaryRules";
var buildColumns = function (handleClickContextMenu) { return [
    {
        field: "actions",
        headerName: "Acciones",
        width: 120,
        renderCell: function (params) {
            var isSinDocument = params.row.code !== "AFU";
            var isStatusEmitida = params.row.status === "Emitida" || isSinDocument;
            if (hasAuditRole()) {
                isStatusEmitida = false;
            }
            var showFinalizarVenta = !params.row.isLegacy &&
                params.row.status === "Pendiente" &&
                (params.row.code === "SPR" || params.row.code === "NPR");
            var menuContext = [
                {
                    disabled: !hasPermission("sale-policies-sumary-see-detail"),
                    icon: {
                        color: "#006ac6",
                        icon: icons.Search,
                        size: sizesIcon.standard,
                    },
                    id: "2",
                    name: "Ver detalles",
                },
                !params.row.isLegacy
                    ? {
                        disabled: isStatusEmitida,
                        icon: {
                            color: "#006ac6",
                            icon: icons.UploadFile,
                            size: sizesIcon.standard,
                        },
                        id: "3",
                        name: "Fiscalizar",
                    }
                    : null,
                showFinalizarVenta
                    ? {
                        disabled: !hasPermission("admin-activate-policy"),
                        icon: {
                            color: "#006ac6",
                            icon: icons.CheckCircle,
                            size: sizesIcon.standard,
                        },
                        id: "5",
                        name: "Finalizar Venta",
                    }
                    : null,
                !params.row.isLegacy
                    ? {
                        disabled: !hasPermission("sale-policies-sumary-cancel") ||
                            params.row.status === "Cancelada",
                        icon: {
                            color: params.row.status === "Cancelada" ||
                                params.row.status === "cancelada" ||
                                params.row.status === "Expirada" ||
                                params.row.status === "expirada"
                                ? "#cccccc"
                                : "#d32f2f",
                            icon: icons.Cancel,
                            size: sizesIcon.standard,
                        },
                        id: "1",
                        name: "Cancelar",
                    }
                    : null,
                !params.row.isLegacy
                    ? {
                        disabled: false,
                        icon: {
                            color: "#006ac6",
                            icon: icons.GridView,
                            size: sizesIcon.standard,
                        },
                        id: "4",
                        name: "Historial",
                    }
                    : null,
            ].filter(Boolean);
            var menuContextV = isSinDocument
                ? menuContext.filter(function (item) { return item.id !== "3"; })
                : menuContext;
            return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: menuContextV, onClickContextMenu: function (item) {
                        return handleClickContextMenu(item, params);
                    }, sizeIcon: sizesIcon.standard }) })));
        },
    },
    {
        editable: false,
        field: "status",
        headerName: "Estado",
        renderCell: function (params) { return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx("span", { className: params.value }), params.value] }))); },
        width: 100,
    },
    {
        field: "isLegacy",
        headerName: "Tipo de póliza",
        width: 130,
        renderCell: function (params) { return (params.value ? "Legacy" : "Assurehub"); },
    },
    {
        field: "quoteDate",
        headerName: "Fecha Cotización",
        width: 120,
    },
    {
        field: "quotation",
        headerName: "Cotización",
        width: 235,
    },
    {
        field: "issueDate",
        headerName: "Fecha Emisión",
        width: 120,
    },
    {
        field: "certificate",
        headerName: "No. Póliza",
        width: 200,
    },
    {
        field: "firstNameA",
        headerName: "Nombres",
        width: 250,
    },
    {
        field: "lastNameA",
        headerName: "Primer apellido",
        width: 170,
    },
    {
        field: "lastNameB",
        headerName: "Segundo apellido",
        width: 170,
    },
    {
        field: "identification",
        headerName: "Identificación",
        width: 150,
    },
    {
        field: "branch",
        headerName: "Sucursal",
        width: 150,
    },
    {
        field: "userName",
        headerName: "Nombre de usuario",
        width: 200,
    },
    {
        field: "codUser",
        headerName: "Usuario",
        width: 175,
    },
    {
        field: "product",
        headerName: "Producto",
        width: 175,
    },
    {
        field: "insuranceCarrier",
        headerName: "Aseguradora",
        width: 175,
    },
    {
        field: "cancellationDate",
        headerName: "Fecha de cancelación",
        width: 170,
    },
    {
        field: "reasonCancellation",
        headerName: "Motivo de cancelación",
        width: 170,
    },
]; };
var buildFilters = function (insuranceOptions, statusOptions, branchOptions) {
    var defaultCheckedStatusItems = getDefaultCheckedStatusItems(statusOptions);
    var hideInsuranceFilter = hasProductPermissionRestriction();
    var filters = [
        {
            active: true,
            backgroundColor: "#E8EEFF",
            border: true,
            borderRadius: "8px",
            borderType: "1px solid #96ABFF",
            color: "#0D1BD9",
            sizes: "40px",
            type: "fullTextSearch",
        },
        {
            backgroundColor: "#f5f7fa",
            color: "#3a56a1",
            fontWeight: 700,
            label: "Limpiar Filtros",
            type: "cleanButton",
            variantButtons: variants.contained,
            visible: true,
        },
        {
            disabled: !hasPermission("sale-policies-sumary-export"),
            label: "Exportar",
            listButtonDropdown: [
                {
                    icons: icons.DownloadForOffline,
                    id: "1",
                    img: newExcel,
                    name: "Descargar Excel",
                },
            ],
            showImage: true,
            type: "exportButton",
            variantButtons: variants.text,
            visible: true,
        },
        {
            id: "dateRange",
            label: "Rango de fechas",
            type: "dateRange",
        },
        {
            listAvatar: insuranceOptions,
            backgroundColor: "#3A56A1",
            color: "#FFFFFF",
            id: "insurance",
            initialSelected: 4,
            surplus: 2,
            type: "avatarSelection",
            width: "225px",
            title: "Productos",
        },
        __assign(__assign({ dropdownIndex: 1, id: "state", label: "Estado", listDropDown: statusOptions, titleSearch: "Buscar" }, (defaultCheckedStatusItems.length > 0 && {
            defaultCheckedItems: defaultCheckedStatusItems,
        })), { allChecked: false, type: "dropdownMultiple", border: true, borderRadius: "8px" }),
        {
            dropdownIndex: 2,
            id: "branchs",
            label: "Sucursales",
            allChecked: false,
            listDropDown: branchOptions,
            titleSearch: "Buscar",
            type: "dropdownMultiple",
            border: true,
            borderRadius: "8px",
        },
        {
            dropdownIndex: 3,
            id: "isLegacy",
            label: "Tipo de póliza",
            isOneSelection: true,
            listDropDown: [
                { id: "1", active: false, name: "Legacy", value: "true" },
                { id: "2", active: false, name: "Assurehub", value: "false" },
            ],
            titleSearch: "Buscar",
            type: "dropdownMultiple",
            border: true,
            borderRadius: "8px",
        },
    ];
    return hideInsuranceFilter
        ? filters.filter(function (filter) { return filter.id !== "insurance"; })
        : filters;
};
export var usePoliciesTable = function (props) {
    var _a = useState(props.limit), limit = _a[0], setLimit = _a[1];
    useEffect(function () {
        if (props.limit !== limit) {
            setLimit(props.limit);
        }
    }, [props.limit]);
    var columns = useMemo(function () { return buildColumns(props.handleClickContextMenu); }, [props.handleClickContextMenu]);
    var filters = useMemo(function () {
        return buildFilters(props.insuranceOptions, props.statusOptions, props.branchOptions);
    }, [props.insuranceOptions, props.statusOptions, props.branchOptions]);
    return {
        columns: columns,
        filters: filters,
        limit: limit,
    };
};
